import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import moment from 'moment-timezone'
import langTranslation from '../langTranslation.json'
import toJS from '../hoc/toJS';


const getTranslationTime = (id, timezone, currentLang, timeString, def=false) => {
    langTranslation
    const translationTime = langTranslation.translationTime
    let transString

    if(timezone && translationTime[id] && currentLang && translationTime[id].format[currentLang]) {
        const momentDate = moment.tz(timeString, timezone)

        transString = momentDate.format(translationTime[id].format[currentLang])
    } else {
        transString = "ERROR"
    }

    return transString
}

const mapStateToProps = (state, ownProps) => ({
    currentLang: state.getIn(['translation', 'currentLang']),
    timezone: state.getIn(['translation', 'timezone']),
})

const TranslationTimeCont = ({
    id,
    timeString,
    currentLang,
    timezone,
    before='',
    after=''
}) => {
    return getTranslationTime(id, timezone, currentLang, timeString, before, after)
}

export default compose(
    connect(mapStateToProps, null),
    toJS(),
)(TranslationTimeCont)